import React from 'react'
import { Outlet } from 'react-router-dom'

import UserList from './UserList'
import UserDetail from './UserDetail'
import UserRegistration from './pages/UserRegistration'

export const routes = {
  guest: [
    {
      path: 'registo/*',
      label: 'Registo',
      element: <UserRegistration />
    }
  ],
  admin: [
    {
      path: 'utilizadores',
      label: 'Utilizadores',
      element: <Outlet />,
      children: [
        { path: '', element: <UserList /> },
        { path: ':userId', label: ({ userId }) => `Utilizador #${userId}`, element: <UserDetail /> }
      ]
    }
  ]
}
